import { useEffect, useState } from 'react';
import { AvatarDataType, publicData } from '../utils';

export const useDashboard = () => {
  const [publicAvatarData, setPublicAvatarData] = useState<AvatarDataType[]>([]);

  useEffect(() => {
    //@ts-ignore
    setPublicAvatarData(publicData);
  }, []);

  return { publicAvatarData };
};
